import React from 'react';
import { COLORS } from '../../../utils/constants';
import './BackButton.css';

const BackButton = ({ onClick, children = 'Back' }) => {
  return (
    <button 
      className="back-button"
      onClick={onClick}
      style={{
        color: COLORS.PRIMARY,
        borderColor: COLORS.PRIMARY
      }}
    >
      ← {children}
    </button>
  );
};

export default BackButton;